import React, { useEffect, useRef } from 'react';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

const Contact = () => {
  const contactRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      },
      { threshold: 0.1 }
    );

    if (contactRef.current) {
      observer.observe(contactRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const contactInfo = [
    {
      icon: Mail,
      label: 'Email',
      value: 'creativa@codeiva.com',
      link: 'mailto:creativa@codeiva.com'
    },
    {
      icon: Phone,
      label: 'WhatsApp',
      value: '+62 878 5777 9888',
      link: 'https://wa.me/6287857779888'
    },
    {
      icon: MapPin,
      label: 'Lokasi',
      value: 'Jember & Bojonegoro',
      link: null
    }
  ];

  const socialLinks = [
    {
      icon: Instagram,
      label: 'Instagram',
      link: 'https://instagram.com/codeiva.creativa/'
    },
    {
      icon: Facebook,
      label: 'Facebook',
      link: 'https://facebook.com/profile.php?id=61579423421481'
    }
  ];

  return (
    <section 
      id="contact" 
      ref={contactRef}
      className="py-20 lg:py-32 bg-gray-50 dark:bg-gray-800 opacity-0 transition-all duration-1000"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
          Mari Berkolaborasi
        </h2>
        <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto mb-12">
          Punya ide kreatif yang ingin diwujudkan? Mari diskusikan bagaimana kami dapat membantu merealisasikan visi Anda.
        </p>

        {/* Informasi Kontak */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {contactInfo.map((info, index) => {
            const IconComponent = info.icon;
            const content = (
              <div className="flex items-center justify-start md:justify-center p-5 bg-white dark:bg-gray-900 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 group">
                <div className="w-12 h-12 bg-gray-900 dark:bg-white rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-200">
                  <IconComponent size={24} className="text-white dark:text-gray-900" />
                </div>
                <div className="text-left">
                  <div className="text-sm text-gray-500 dark:text-gray-400">{info.label}</div>
                  <div className="text-gray-900 dark:text-white font-semibold">{info.value}</div>
                </div>
              </div>
            );

            return info.link ? (
              <a key={index} href={info.link} target="_blank" rel="noopener noreferrer">
                {content}
              </a>
            ) : (
              <div key={index}>{content}</div>
            );
          })}
        </div>

        {/* Ikuti Kami */}
        <div>
          <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Ikuti Kami
          </h4>
          <div className="flex justify-center space-x-4">
            {socialLinks.map((social, index) => {
              const IconComponent = social.icon;
              return (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-900 dark:bg-white rounded-lg flex items-center justify-center hover:scale-110 transition-transform duration-200"
                  aria-label={social.label}
                >
                  <IconComponent size={24} className="text-white dark:text-gray-900" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
